<div class="sidenav">
    <h4>About Us</h4>
    <a href="/about">What it's all about</a>
    <mat-divider></mat-divider>
    <a style="font-weight: bold; color: #753457;">Friends and Partners</a>
    <mat-divider></mat-divider>
    <a href="/getintouch">Get in touch</a>
    <mat-divider></mat-divider>
    <a href="/apidocs">API docs</a>
  </div>


  <div class="navmobile">
    <h4>About Us</h4>
    <a href="/about">What it's all about</a>
    <mat-divider></mat-divider>
    <a style="font-weight: bold; color: #753457;">Friends and Partners</a>
    <mat-divider></mat-divider>
    <a href="/getintouch">Get in touch</a>
    <mat-divider></mat-divider>
    <a href="/apidocs">API docs</a>
  </div>
  
  <div class="center">
    <h2>Friends & Partners</h2>
    <div class="row">

        <p><strong>
            For the largest impact possible, the Lebtivity team has been constantly on the lookout for wonderful people whose mission coincides with ours.
        </strong>
        </p>
    </div>
    <div *ngFor="let partner of partnersList; let i = index" class="row">
        <h3><span>{{partner.name}}</span></h3>
        <p style="margin-top: 40px;">{{partner.description}}</p>
        <div class="col-md"  *ngFor="let detail of partnersList[i].partners">
        <img class="partnerimage" src="https://images-lebtivity.s3.amazonaws.com/{{detail.image}}">
    </div>
</div>

    <div class="row">

        <p>Do you have an interesting initiative and believe we should join forces? Don't hesitate to reach out!</p>
       <button mat-raised-button class="letsbefriends">Let's be friends!</button>

    </div>


     </div>  
  